const LISTING_REEL_PATH = /^\/source\/s3\/cabinet-assets\/.*\/video\/listing-reel\//u;

/**
 * Routes a cabinet listing-reel URL through Cloudflare Media Transformations at
 * the requested width. Widths come from a fixed snapped set, never a measured
 * `clientWidth * devicePixelRatio`: each distinct width is its own edge cache
 * entry whose cold transform a real viewer pays for, which is the same reason
 * `srcset` snaps to a ladder. Anything that is not a cabinet reel passes
 * through untouched.
 */
export const listingReelTransformUrl = (url: string, width: number): string => {
  const parsed = new URL(url);
  if (!LISTING_REEL_PATH.test(parsed.pathname)) {
    return url;
  }
  return `${parsed.origin}/cdn-cgi/media/mode=video,width=${width}${parsed.pathname}`;
};
